<template>
  <nav class="watchlist-filters">
    <div v-if="events" class="home__list-nav">
      <a
        href="#"
        class="home__list-nav-item"
        :class="{ _active: filterUnread && $route.query.mode !== 'all' }"
        @click.prevent="$emit('filter-unread-click', true)"
      >
        Непрочтённые [{{ unreadCount || 0 }}]
      </a>

      <a
        href="#"
        class="home__list-nav-item"
        :class="{ _active: !filterUnread || $route.query.mode === 'all' }"
        @click.prevent="$emit('filter-unread-click', false)"
      >
        Все
      </a>
    </div>

    <div
      v-for="event in events"
      :key="event.id"
      class="watchlist-filter"
      :class="{
        _disabled:
          !filterUnread || !event.unreadCount || $route.query.mode === 'all'
      }"
    >
      <a
        v-if="filterUnread && event.unreadCount"
        href="#"
        class="watchlist-filter__title"
        @click.prevent="$emit('menu-item-click', {event})"
      >
        {{ event.name }}
      </a>

      <span v-else class="watchlist-filter__title">
        {{ event.name }}
      </span>
      
      <dropdown-menu cssClass="watchlist-filter__dropdown">
        <template #dropdown-menu__button>
          <div
            class="watchlist-filter__select"
            :class="{ _selected: event.id === curEventId }"
          >
            <svg width="10" height="10">
              <use xlink:href="#chevron" />
            </svg>
            
            {{ getEventValue(event) }}
          </div>
        </template>

        <template #dropdown-menu__list>
          <span
            v-for="period in event.periods"
            :key="period.id"
            class="dropdown-menu__item"
            @click="$emit('menu-item-click', {event, period})"
          >
            {{ period.name }}
          </span>
        </template>
      </dropdown-menu>
    </div>
  </nav>
</template>

<script>
import DropdownMenu from '@@/shared/DropdownMenu';

export default {
  components: {
    DropdownMenu
  },

  props:{
    events: {
      required: true
    },
    unreadCount: {
      required: true
    },
    filterUnread: {
      default: () => true
    },
    curEventId: {
      default: () => null
    },
    curPeriodId: {
      default: () => null
    }
  },

  methods: {
    getEventValue(event) {
      if (event.id !== this.curEventId) return '';

      let curPeriod = event.periods.find(
        period => period.id === this.curPeriodId
      );

      return curPeriod ? curPeriod.name : '';
    }
  }
};
</script>
